import classNames from 'classnames';

interface UiLabelProps {
  title: string;
  type?: 'uppercase' | 'small';
  className?: string;
  color?: 'auto' | string;
}

export const UiLabel: React.FC<UiLabelProps> = ({ title, type = 'uppercase', className, color }) => {
  return (
    <span
      className={classNames(
        {
          'px-3 rounded-full text-[10px] leading-5 uppercase': type === 'uppercase',
          'py-1 mb-1 text-xs': type === 'small',
        },
        className
      )}
    >
      {title}
    </span>
  );
};
